import { createState, useState } from '@hookstate/core';
import Helper from '../utility/helper';
const initialState = {
    visible: false,
    user: '',
};

const agentState = createState(initialState);

export const setAgentVisible = (props) => {
    if (props) {
        agentState.set({
            ...initialState,
            visible: true,
            user: props,
        });
        Helper.setSessionStorage('agentUser', props);
    }
    return;
};
export const useAgentState = () => {
    return useState(agentState);
};
export const handleAgentClose = () => {
    Helper.removeStorage('agentInfo');
    Helper.removeStorage('agentConnections');
    Helper.removeStorage('agentUser');
    agentState.set(initialState);
};

export const handleAgentEventClose = () => {
    const agentInfo = Helper.getStorage('agentInfo');
    if (agentState.visible.value) {
        Helper.setStorage('userInfo', agentInfo);
    }
    Helper.removeStorage('agentConnections');
    Helper.removeStorage('agentUser');
    agentState.set(initialState);
};
